import { AnimatePresence } from 'framer-motion'
import { Container } from 'src/components/common/Container'
import { layoutMaxSize } from 'src/styles/mixin'
import styled, { css } from 'styled-components'
import { Outlet, ScrollRestoration, useLocation, useNavigationType } from 'react-router-dom'
import { useModal } from 'src/provider/ModalContextProvider'
import Header from 'src/components/layout/Header'
import Footer from 'src/components/layout/Footer'
import ContentsLayout from 'src/components/layout/ContentsLayout'
import Modal from 'src/components/common/Modal'
import Toast from 'src/components/common/Toast'
import TopButton from 'src/components/common/TopButton'
import RenderIf from 'src/components/common/RenderIf'
import React from 'react'
import usePathMatch from 'src/hooks/usePathMatch.hook'
import { useToast } from 'src/provider/ToastContextProvider'
import { useGlobalStore } from 'src/store/zustand'

const PageLayoutView = () => {
  const { pathname } = useLocation()
  const { isOpen: modalOpen } = useModal()
  const { isOpen: toastOpen } = useToast()
  const navigationType = useNavigationType()
  const { match_coupon_map, match_join_cert } = usePathMatch()
  const { joinCertHeaderTitleOverride } = useGlobalStore()

  const joinCertGuestLayout = match_join_cert && !!joinCertHeaderTitleOverride

  return (
    <React.Fragment>
      {/*카카오 맵 동적 사이즈 이슈로 인한 outlet 분리*/}
      <Container $option="flex_column_space_between" $style={PageLayoutViewWrap}>
        {pathname && <Header />}
        <RenderIf when={joinCertGuestLayout}>
          <FixedHeaderBlank />
        </RenderIf>
        <RenderIf when={match_coupon_map}>
          <Outlet />
        </RenderIf>
        <RenderIf when={!match_coupon_map}>
          {/*등장 애니메이션으로 인해 key값 부여*/}
          <ContentsLayout key={navigationType !== 'POP' ? pathname : ''}>
            <AnimatePresence>
              <Outlet />
            </AnimatePresence>
          </ContentsLayout>
        </RenderIf>
        <Footer />
      </Container>
      {/*Float Component*/}
      <RenderIf when={toastOpen}>
        <Toast />
      </RenderIf>
      <TopButton />
      <RenderIf when={modalOpen}>
        <Modal />
      </RenderIf>
      <ScrollRestoration
        getKey={(location, matches) => {
          return location.pathname
        }}
      />
    </React.Fragment>
  )
}
export default PageLayoutView

const PageLayoutViewWrap = css`
  ${layoutMaxSize};
  min-width: 320px;
  background-color: var(--white) !important;
  margin: 0 auto;
  overflow: hidden;
  min-height: calc(var(--vh, 1vh) * 100);
  height: 100%;

  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    display: none;
  }
`
const FixedHeaderBlank = styled.div`
  height: 50px;
`
